import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const CheckIcon = ({ label = 'Check', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="m263.4 78-16.8-16.4c-2.2-2.4-4.8-4.8-8-4.8s-6 2.4-8.4 4.8L120.8 171l-51-51.1c-2.4-2.4-5.2-4.8-8.4-4.8s-5.8 2.4-8 4.8l-16.8 16.4c-2.1 2.2-4.4 4.9-4.4 8.2s2.3 6.1 4.4 8.2l76 75.7c2.2 2.4 4.9 4.8 8.2 4.8s6.1-2.4 8.2-4.8l134.4-134c2.1-2.1 4.4-4.8 4.4-8.2s-2.3-6-4.4-8.2z" style="fill:#b1ce5f"/><path d="M238.6 56.8c3.2 0 5.8 2.4 8 4.8L263.4 78c2.1 2.2 4.4 4.9 4.4 8.2s-2.3 6.1-4.4 8.2L129 228.4c-2.1 2.4-4.8 4.8-8.2 4.8s-6-2.4-8.2-4.8l-76-75.7c-2.1-2.1-4.4-4.8-4.4-8.2s2.3-6 4.4-8.2l16.8-16.4c2.2-2.4 4.8-4.8 8-4.8s6 2.4 8.4 4.8l51 51.1L230.2 61.6c2.4-2.4 5.2-4.8 8.4-4.8m0-10c-7.7 0-13.2 5.4-15.5 7.8L120.8 156.8l-43.9-43.9c-2.3-2.4-7.8-7.8-15.5-7.8s-13.2 5.7-15.2 8l-16.6 16.1a.1.1 0 0 0-.1.1c-2 2-7.3 7.3-7.3 15.2s5.3 13.3 7.3 15.3l75.9 75.4c2 2.3 7.3 8 15.4 8s13.5-5.7 15.5-8l134.2-133.7c2-2 7.3-7.3 7.3-15.3S272.5 73 270.5 71h-.1l-16.6-16.2c-2-2.4-7.3-8-15.2-8z" style="fill:#1d1d1b"/><path d="M151.5 187.6a4.6 4.6 0 0 1-3.4-1.5 4.9 4.9 0 0 1 0-6.9l23.2-23.3a4.9 4.9 0 0 1 7 7L155 186.1a4.7 4.7 0 0 1-3.5 1.5zm-26.3 26.3a5 5 0 0 1-3.5-1.5 4.9 4.9 0 0 1 0-6.9l4.7-4.7a4.9 4.9 0 0 1 6.9 0 4.8 4.8 0 0 1 0 7l-4.6 4.6a4.9 4.9 0 0 1-3.5 1.5z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

CheckIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { CheckIcon }
